
import { Link } from "react-router-dom"
import Logo from '../images/3.png'
import { FaFacebook } from "react-icons/fa"
import { FaWhatsapp } from "react-icons/fa"
import { FaYoutube } from "react-icons/fa"

const Footer = () => {
  return (
    <footer>
        <div className="container footer__container">
            <article>
                <Link className="logo">
                    <img src={Logo} alt="Logo -Ekip" />
                </Link>
                <p>
                      Notre agence est spécialisée dans la création de sites internet et d'applications mobiles. Nous vous offrons des solutions personnalisées pour répondre à vos besoins. Contactez-nous dès maintenant pour en savoir plus !
                </p>
                <div className="footer__socials">
                    <a href="https://facebook.com/" rel="noreferrer noopener" target="_blank" > {<FaFacebook/>} </a>
                    <a href="https://whatsapp.com/" rel="noreferrer noopener" target="_blank" > {<FaWhatsapp/>} </a>
                    <a href="https://youtube.com/" rel="noreferrer noopener" target="_blank" > {<FaYoutube/>} </a>
                </div>
            </article>
            <article>
                <h4>Permaliens</h4>
                <Link to="/about" >À Propos</Link>
                <Link to="/gallery" >Gallerie</Link>
                <Link to="/plans" >Plans</Link>
                <Link to="/prof" >Professeurs</Link>
                <Link to="/contact" >Contact</Link>
            </article>
              <article>
                  <h4>Insights</h4>
                  <Link to="/s" >Blog</Link>
                  <Link to="/s" >Cas d'Etudes</Link>
                  <Link to="/s" >Evenements</Link>
                  <Link to="/s" >Comnunautés</Link>
                  <Link to="/" >FAQs</Link>
              </article>
              <article>
                  <h4>Nous Contacter</h4>
                  <Link to="/contact" >Contact</Link>
                  <Link to="/s" >Soutenir</Link>
              </article>
        </div>
        <div className="footer__copyright">
            <small>
                  2023  <a href="mailto:sethagbaaa@gmail.com" target="_blank" rel="noreferrer" > sethagbaa@gmail.com</a> &copy; Tous Droits Reservés
            </small>
        </div>
    </footer>
  )
}

export default Footer
